/* ATLAS cart drawer.
   Split out of atlas.js so each file stays small. Exposes window.AtlasCart
   so the product forms in atlas.js can open and refresh the drawer.

   Customer-facing naming: the variant title is the supplier's option string
   ("black-Pumps", and the SKU carries "14:200000195#..."). That must never
   reach a customer, so a variant line renders only when the title carries no
   supplier punctuation and does not name the bundled pump. */
(function () {
  'use strict';
  if (window.AtlasCart) return;

  var money = function (c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; };

  var drawer, lastFocus = null, busy = false;

  function cfg(k, d) { return (drawer && drawer.dataset[k]) || d || ''; }

  function showVariant(t) {
    if (!t || t === 'Default Title') return '';
    if (/[#:]/.test(t)) return '';
    if (/pump/i.test(t)) return '';
    return t;
  }

  function setBusy(on) {
    busy = on;
    if (!drawer) return;
    drawer.classList.toggle('at-cd--busy', on);
    drawer.setAttribute('aria-busy', on ? 'true' : 'false');
    $$('button', drawer).forEach(function (b) {
      if (b.classList.contains('at-cd__close')) return;
      if (on) b.setAttribute('disabled', 'disabled'); else b.removeAttribute('disabled');
    });
  }

  function err(msg) {
    var e = $('[data-atlas-cart-error]', drawer);
    if (e) { e.textContent = msg || ''; e.hidden = !msg; }
    var live = $('[data-atlas-live]');
    if (live && msg) live.textContent = msg;
  }

  function render(cart) {
    if (!drawer) return;
    var body = $('.at-cd__body', drawer);
    var foot = $('.at-cd__foot', drawer);
    $$('[data-atlas-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
    $$('[data-atlas-bag-label]').forEach(function (n) { n.textContent = 'Bag (' + cart.item_count + ')'; });

    if (!cart.item_count) {
      body.innerHTML = '<p class="at-cd__empty">Your bag is empty.</p>';
      if (foot) foot.hidden = true;
      renderOffer(cart);
      return;
    }
    if (foot) foot.hidden = false;

    body.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      var vt = showVariant(it.variant_title);
      var inc = cfg('included', '');
      return '<div class="at-cd__item" data-line="' + (i + 1) + '">' +
        (img ? '<img class="at-cd__thumb" src="' + img + '" alt="" width="72" height="90" loading="lazy">'
             : '<span class="at-cd__thumb"></span>') +
        '<div class="at-cd__meta">' +
          '<p class="at-cd__name">' + esc(it.product_title) + '</p>' +
          (vt ? '<p class="at-cd__var">' + esc(vt) + '</p>' : '') +
          (inc ? '<p class="at-cd__inc">' + esc(inc) + '</p>' : '') +
          '<div class="at-cd__row">' +
            '<div class="at-cd__qty">' +
              '<button type="button" data-atlas-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-atlas-qty="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="at-cd__rm" data-atlas-remove aria-label="Remove ' + esc(it.product_title) + ' from your bag">Remove</button>' +
          '</div>' +
        '</div>' +
        '<span class="at-cd__line">' + money(it.final_line_price) + '</span>' +
      '</div>';
    }).join('');

    var tot = $('[data-atlas-total]', drawer);
    if (tot) tot.textContent = money(cart.total_price);
    var was = $('[data-atlas-was]', drawer);
    if (was) {
      var saved = cart.original_total_price - cart.total_price;
      was.hidden = saved <= 0;
      was.textContent = saved > 0 ? money(cart.original_total_price) : '';
    }
    renderOffer(cart);
  }

  function renderOffer(cart) {
    var box = $('[data-atlas-duo]', drawer);
    if (!box) return;
    if (cfg('duo') !== 'on') { box.hidden = true; return; }
    var qty = cart.item_count || 0;
    box.hidden = false;
    box.classList.toggle('is-active', qty >= 2);
    var btn = $('[data-atlas-duo-add]', box);
    if (btn) btn.textContent = qty >= 2 ? 'Back to one' : (cfg('duoCta') || 'Add the second');
  }

  /* Always resolves. A rejected cart fetch used to leave the caller's
     .then(open) unreached, so a rate-limited or offline shopper clicked the
     bag and got nothing at all -- no drawer, no message. Now the drawer opens
     first and this reports the failure inside it. */
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (c) { err(''); render(c); return c; })
      .catch(function () { err('We could not load your bag. Please try again.'); return null; });
  }

  function change(line, quantity) {
    if (busy) return Promise.resolve();
    setBusy(true); err('');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: quantity })
    })
      .then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
      .then(render)
      .catch(function () { err('We could not update your bag. Please try again.'); })
      .then(function () { setBusy(false); });
  }

  function addQty(id, quantity) {
    if (busy) return Promise.resolve();
    setBusy(true); err('');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return getCart(); })
      .catch(function (j) { err((j && (j.description || j.message)) || 'This item could not be added.'); })
      .then(function () { setBusy(false); });
  }

  function focusables() {
    return $$('button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', drawer)
      .filter(function (e) { return e.offsetParent !== null || e === document.activeElement; });
  }

  function onKey(e) {
    if (!drawer || !drawer.classList.contains('at-cd--on')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open() {
    if (!drawer) return;
    if (!drawer.classList.contains('at-cd--on')) lastFocus = document.activeElement;
    drawer.classList.add('at-cd--on');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var c = $('.at-cd__close', drawer);
    if (c) c.focus();
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('at-cd--on');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function init() {
    drawer = $('[data-atlas-drawer]');
    if (!drawer) return;

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('.at-cd__scrim') || e.target.closest('.at-cd__close')) {
        e.preventDefault(); close(); return;
      }
      var item = e.target.closest('.at-cd__item');
      var line = item && item.getAttribute('data-line');

      if (e.target.closest('[data-atlas-remove]')) { change(line, 0); return; }

      var q = e.target.closest('[data-atlas-qty]');
      if (q && item) {
        var cur = parseInt($('.at-cd__qty span', item).textContent, 10) || 0;
        var next = cur + parseInt(q.getAttribute('data-atlas-qty'), 10);
        change(line, next < 0 ? 0 : next);
        return;
      }

      if (e.target.closest('[data-atlas-duo-add]')) {
        var id = cfg('variant');
        if (!id) return;
        getCart().then(function (c) {
          if (!c) return;
          if ((c.item_count || 0) >= 2) return change(1, 1);
          return c.item_count ? change(1, 2) : addQty(id, 2);
        });
      }
    });

    document.addEventListener('keydown', onKey);
    $$('[data-atlas-open-cart]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        open();          // open first: never leave a click with no response
        getCart();
      });
    });
    getCart();
  }

  window.AtlasCart = { open: open, close: close, refresh: getCart, add: addQty, error: err, busy: function () { return busy; } };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
